/*
Suresh Peddavoora 12/22/2022 3075154998 Added Table for Preprocessor Table
Akhila 12/28/2022 3075154998 Added Add  Action popUp and Added Fields
Sohel 12/29/2022 3075154998 Added edit Icon
Akhila 12/30/2022 3075154998 Added Condtion for empty Data in table
Sai Maheshwar 01/13/2023 2699704333 fixed action edit and delete
Sohel 01/13/2023 2699704333 changed delete condition and popup message
Sohel 01/17/2023 2698964415 change popup delete message
Sohel 01/24/2023 2698964415 removed space between Temp repo
Ashraf 04/02/2023 2698964415 Added bypass and bypass record actions
Sohel 03/14/2023 2698964415 Added Error Reason in Payload
Dilip 03/28/2023 2698964415 Fixed delete id's in save api payload issue.
Sohel 04/08/2023 2698964415 Change Status and Change client Payload nad Validation Changes
Sohel 04/19/2023 2698964415 Added Error Record in Exports
Prakash 04/19/2020 2698964415 Added CSS For Table Text Wrap issue.
Akhila 04/24/2023 2698964415 bug fixed and prepoulated data
Sohel 10/10/2023 2700912712 Fixed Repository Name Space Issue
*/
import React, {useRef, useState} from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {
  IconButton,
  Tooltip,
} from '@material-ui/core';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import PageLoader from '../../../../../components/PageLoader';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {useSelector} from 'react-redux';
const DMREditTableData = ({
  setActionFormData,
  actionformData,
  isActionEditMode,
  setIsActionEditMode,
  setActionRowData,
  setActionOldRuleCode,
  conditionalProps,
  actionDeleteIdsRef,
  exportManagerRecord,
}) => {
  const {value, handleValueChange, name} = conditionalProps;
  const isDataTransformation = ['Y', true]?.includes(conditionalProps?.value?.isDataTransformation) ?
    true :
    false;
  const record = useRef();
  const {basicInfoData: recordGroupData} = useSelector(
    ({dataManagerRecordGroup}) => dataManagerRecordGroup,
  );
  const {basicInfoData} = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const actionData = exportManagerRecord ?
    ['Data Export', 'Header', 'Footer']?.includes(
      basicInfoData?.recordType ?
        basicInfoData?.recordType :
        recordGroupData?.groupType ?
          recordGroupData?.groupType :
          '',
    ) :
    ['New Account Import', 'Data Update']?.includes(
      basicInfoData?.recordType ?
        basicInfoData?.recordType :
        recordGroupData?.groupType ?
          recordGroupData?.groupType :
          '',
    );
  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'SEQ No',
    },
    {
      title: 'Action(s)',
    },
    {
      title: 'Field',
    },
    {
      title: 'Parameter(s)',
    },
    {
      title: 'Error Reason',
      hidden: !actionData,
    },
  ];

  const [isDelete, setIsDelete] = useState(false);
  const [loader, setLoader] = useState(false);
  const actionRule = useRef('');
  const actionIndex = useRef(null);
  const handleSubmit = () => {
    setLoader(true);
    setTimeout(() => {
      const data = [...value.actions];
      const newData = data.filter((row, i) => i !== actionIndex.current);
      const key = actionRule?.current?.processorCode;
      if (key && actionDeleteIdsRef.current?.[key]) {
        actionDeleteIdsRef.current[key] = [
          ...actionDeleteIdsRef.current[key],
          actionRule.current.dataManagerProcessorActionId,
        ];
      } else if (key) {
        actionDeleteIdsRef.current[key] = [actionRule.current.dataManagerProcessorActionId];
      }
      // setActionFormData(newData);
      handleValueChange(`${name}.actions`, newData);
      handleCloseDialog();
      setLoader(false);
    }, 1000);
  };

  const handleCloseDialog = () => {
    setIsDelete(false);
  };

  const reorderItems = (startIndex, endIndex) => {
    const arr = [...value.actions];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    // setActionFormData(arr);
    handleValueChange(`${name}.actions`, arr);
  };

  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };
  const getStatusParameters = (params) => {
    const ar = [];
    Object.entries(params).forEach(([key, value]) => {
      if (key === 'disposition') {
        value ? ar.push(`status : "${value}"`) : null;
      } else if (key !== 'dispositionType') {
        value ? ar.push(`${key} : "${value}"`) : null;
      }
    });
    return ar.filter(Boolean).join(', ');
  };
  return (
    <>
      <div
        className={`mui-custom-table-container custom-table  pt-0 global-field-table text-left-table new-standard-textfields `}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <table>
            <thead className="recFormat-header-container">
              <tr>
                {columns.map(
                  ({title, hidden = false}) =>
                    !hidden && (
                      <th key={title} className="recFormat-header">
                        {title}
                      </th>
                    ),
                )}
              </tr>
            </thead>
            <Droppable droppableId="droppabe-list">
              {(provided) => (
                <tbody ref={provided.innerRef} className="recFormat-body">
                  {value?.actions?.length > 0 ? (
                    value?.actions?.map((el, index) => {
                      return (
                        <Draggable key={index} draggableId={'draggable-' + index} index={index}>
                          {(provided) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <td className="recFormat-col recFormat-center">
                                <Tooltip title="Edit">
                                  <IconButton
                                    disabled={isDataTransformation}
                                    onClick={(e) => {
                                      setIsActionEditMode(true);
                                      setActionRowData({...el, index});
                                      // setOldRuleCode(el.ruleCode);
                                    }}
                                  >
                                    <EditOutlinedIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <IconButton
                                    disabled={isDataTransformation}
                                    onClick={(e) => {
                                      setIsDelete(true);
                                      actionIndex.current = index;
                                      actionRule.current = el;
                                      record.current = el;
                                    }}
                                  >
                                    <DeleteOutlined />
                                  </IconButton>
                                </Tooltip>
                              </td>
                              <td className="recFormat-col global-field-textfields">{index + 1}</td>
                              <td className="recFormat-col global-field-textfields">
                                {el?.action ? el?.action : el?.actionName}
                              </td>
                              {exportManagerRecord && el?.action === 'Error Record' ? (
                                <td className="recFormat-col recFormat-center">
                                  {el?.selectField ? el?.selectField : ''}
                                </td>
                              ) : (
                                <td className="recFormat-col recFormat-center">
                                  <div
                                    style={{
                                      whiteSpace: 'pre-wrap',
                                      minWidth: '350px',
                                      wordBreak: 'break-all',
                                    }}
                                  >
                                    {el?.selectField?.repositoryName ?
                                      el?.selectField?.repositoryName +
                                        '.' +
                                        el?.selectField?.fieldName :
                                      el?.repositoryFromName ?
                                        el?.repositoryFromName +
                                        '.' +
                                        el?.fieldFromName :
                                        '-'}
                                  </div>
                                </td>
                              )}
                              <td className="recFormat-col global-field-textfields">
                                <div
                                  style={{
                                    whiteSpace: 'pre-wrap',
                                    minWidth: '350px',
                                    wordBreak: 'break-all',
                                  }}
                                >
                                  {el?.action === 'Change Status' ?
                                    getStatusParameters(el?.parameter) :
                                    el?.parameter ?
                                      el?.parameter :
                                      el?.rhsFormulaExpression ?
                                        el?.rhsFormulaExpression :
                                        ''}
                                </div>
                              </td>

                              {actionData && (
                                <td className="recFormat-col global-field-textfields">
                                  {el?.errorReason}
                                </td>
                              )}
                            </tr>
                          )}
                        </Draggable>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.length}>
                        No records to display. To add Action Fields to your PreProcessor click the
                        &quot;+ Add Action&quot; button in the top right of this section.
                      </td>
                    </tr>
                  )}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Action"
        value={`Are you sure you want to delete this ${
          record.current?.selectField?.repositoryName ?
            record.current?.selectField?.repositoryName +
              '.' +
              record.current?.selectField?.fieldName :
            ''
        } Action : ${
          record.current?.actionName ? record.current?.actionName : record.current?.action
        } ?`}
        handleSubmit={handleSubmit}
      />
      {loader && <PageLoader />}
    </>
  );
};

export default DMREditTableData;
